import * as Models from "../Models";
import * as UserService from "./UserService";
    export interface IBrandingService {
        getLogoPathForPartner: () => ng.IPromise<any>;
    }

    export class BrandingService implements IBrandingService {
        public user: Models.UserModel.UserModel;
        public partner: Models.PartnerModel.IPartnerModel;

        public static $inject = [
            'UserService',
            '$q'
        ];

        constructor(private userService: UserService.IUserService,
            private $q: angular.IQService) {
        }

        public getLogoPathForPartner = (): ng.IPromise<any> => {
            var deferred = this.$q.defer();
            this.getUserAndPartnerDetail().then((partner: Models.PartnerModel.IPartnerModel) => {
                deferred.resolve(partner.logoPath);
            });
            return deferred.promise;
        }

        private getUserAndPartnerDetail = (): ng.IPromise<any> => {
            var deferred = this.$q.defer();
            this.userService.getCurrentUser().then((data: Models.UserModel.UserModel) => {
                if (!this.user || this.user.userId !== data.userId) {
                    this.user = data;
                    this.partner = this.user.partner;
                    deferred.resolve(this.partner);
                } else {
                    deferred.resolve(this.partner);
                }
            });
            return deferred.promise;
        }
    }
